export default __webpack_public_path__ + "static/media/memories.04d19366.PNG";